import React, { useState, Fragment, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, Button, Form } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import api from "../../../api";
import swal from "sweetalert";

const INDIAN_STATES = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

const VendorAdd = () => {
 const navigate = useNavigate();
 const [loading, setLoading] = useState(false);
 const [categories, setCategories] = useState([]);
 // ===========================
 // VALIDATION REGEX
 // ===========================
 const phoneRegex = /^\+?[1-9]\d{7,14}$/;
 const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
 const aadhaarRegex = /^[0-9]{12}$/;

 const gstRegex =
 /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/;

 const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

 const accountRegex = /^[0-9]{9,18}$/;
 const [form, setForm] = useState({
 name: "",
 category: "",
 contactPerson: "",
 email: "",
 phone: "",
 address: "",
 state: "",
 gst: "",
 panNumber: "",
 aadhaarNumber: "",
 panDocument: null,
 aadhaarDocument: null,
 bank: {
 bankName: "",
 accountHolder: "",
 accountNo: "",
 confirmAccountNo: "",
 ifsc: "",
 },
 status: "Active",
 });

 const statuses = ["Active", "Inactive", "Blacklisted"];

 useEffect(() => {
 fetchCategories();
 }, []);

 const fetchCategories = async () => {
 try {
 const response = await api.get("/vendor-categories");
 if (response.data.success) {
 setCategories(response.data.data);
 }
 } catch (error) {
 swal("Error", "Failed to load categories", "error");
 }
 };

 const handleChange = (e) => {
 let { name, value } = e.target;

 // Prevent numbers in name fields
 if (name === "name" || name === "contactPerson") {
 value = value.replace(/[0-9]/g, "");
 }

 if (name === "phone") {
 value = value.replace(/[^0-9+]/g, "");

 // allow only + at first position
 if (value.includes("+")) {
 value = "+" + value.replace(/\+/g, "").replace(/^\+/, "");
 }
}
 // GST uppercase
 if (name === "gst") {
 value = value.toUpperCase();
 }

 if (name === "panNumber") {
 value = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
 }

 if (name === "aadhaarNumber") {
 value = value.replace(/\D/g, "");
 }

 setForm((prev) => ({ ...prev, [name]: value }));
 };

 const handleFileChange = (e) => {
 const { name, files } = e.target;
 setForm((prev) => ({
 ...prev,
 [name]: files?.[0] || null,
 }));
 };

 // HANDLE BANK VALUE CHANGE
 const handleBankChange = (e) => {
 let { name, value } = e.target;

 if (name === "accountNo" || name === "confirmAccountNo") {
 value = value.replace(/\D/g, "");
 }

 if (name === "ifsc") {
 value = value.toUpperCase();
 }

 setForm((prev) => ({
 ...prev,
 bank: { ...prev.bank, [name]: value },
 }));
 };

 // ===========================
 // HANDLE BACKEND ERROR PRINT
 // ===========================
 const printBackendError = (error) => {
 const data = error.response?.data;

 if (!data) {
 return swal("Error", "Server not reachable", "error");
 }

 // Mongo duplicate key error
 if (data.error && data.error.includes("duplicate key")) {
 if (data.error.includes("email")) {
 return swal("Error", "Email already exists", "error");
 }

 return swal("Error", "Duplicate record already exists", "error");
 }

 // Express validation errors
 if (Array.isArray(data.errors) && data.errors.length > 0) {
 const list = data.errors.map((e) => `• ${e.msg}`).join("\n");
 return swal("Validation Error", list, "warning");
 }

 swal("Error", data.error || data.message || "Something went wrong", "error");
};

 const handleSubmit = async (e) => {
 e.preventDefault();

 // VALIDATION USING SWAL
 if (!form.name)
 return swal("Warning", "Please enter vendor name", "warning");
 if (!form.category)
 return swal("Warning", "Please select a category", "warning");
 if (!form.contactPerson)
 return swal("Warning", "Please enter contact person", "warning");
 if (!form.state) return swal("Warning", "Please enter state", "warning");
 if (!form.email) return swal("Warning", "Please enter email", "warning");
 if (!form.phone)
 return swal("Warning", "Please enter phone number", "warning");
 if (!form.address)
 return swal("Warning", "Please enter address", "warning");
 // PHONE VALIDATION
 if (!phoneRegex.test(form.phone))
 return swal(
 "Warning",
 "Enter valid phone number with optional country code (e.g. +919876543210)",
 "warning"
 );

 // GST VALIDATION (only if filled)
 if (form.gst && !gstRegex.test(form.gst))
 return swal("Warning", "Invalid GST Number", "warning");

 if (form.panNumber && !panRegex.test(form.panNumber))
 return swal("Warning", "Invalid PAN Number", "warning");

 if (form.aadhaarNumber && !aadhaarRegex.test(form.aadhaarNumber))
 return swal("Warning", "Invalid Aadhaar Number", "warning");

 // ACCOUNT NUMBER VALIDATION
 if (form.bank.accountNo && !accountRegex.test(form.bank.accountNo))
 return swal("Warning", "Invalid Account Number", "warning");

 // CONFIRM ACCOUNT NUMBER MATCH
 if (
 form.bank.accountNo &&
 form.bank.confirmAccountNo &&
 form.bank.accountNo !== form.bank.confirmAccountNo
 )
 return swal("Warning", "Account numbers do not match", "warning");

 // IFSC VALIDATION
 if (form.bank.ifsc && !ifscRegex.test(form.bank.ifsc))
 return swal("Warning", "Invalid IFSC Code", "warning");
 // BANK CONFIRM VALIDATION (only if filled)
 if (
 form.bank.accountNo ||
 form.bank.confirmAccountNo ||
 form.bank.bankName ||
 form.bank.ifsc
 ) {
 if (!form.bank.accountNo)
 return swal("Warning", "Please enter account number", "warning");
 if (!form.bank.confirmAccountNo)
 return swal("Warning", "Please confirm account number", "warning");
 if (form.bank.accountNo !== form.bank.confirmAccountNo)
 return swal("Warning", "Account numbers do not match!", "warning");
 }

 try {
 setLoading(true);
 const formData = new FormData();
 formData.append("name", form.name);
 formData.append("category", form.category);
 formData.append("contactPerson", form.contactPerson);
 formData.append("email", form.email);
 formData.append("phone", form.phone);
 formData.append("address", form.address);
 formData.append("state", form.state);
 formData.append("gst", form.gst || "");
 formData.append("panNumber", form.panNumber);
 formData.append("aadhaarNumber", form.aadhaarNumber);
 formData.append("bankName", form.bank.bankName || "");
 formData.append("accountHolder", form.bank.accountHolder || "");
 formData.append("accountNo", form.bank.accountNo || "");
 formData.append("ifsc", form.bank.ifsc || "");
 formData.append("status", form.status);

 if (form.panDocument) {
 formData.append("panDocument", form.panDocument);
 }

 if (form.aadhaarDocument) {
 formData.append("aadhaarDocument", form.aadhaarDocument);
 }

 const response = await api.post("/vendors", formData);

 if (response.data.success) {
 await swal("Success", "Vendor created successfully!", "success");
 navigate("/vendors");
 }
 } catch (error) {
 printBackendError(error);
 } finally {
 setLoading(false);
 }
 };

 return (
 <Fragment>
 <PageTitle activeMenu="Add Vendor" motherMenu="Vendor Management" />

 <Row>
 <Col lg={12}>
 <Card>
 <Card.Header className="d-flex justify-content-between align-items-center">
 <Card.Title>Add New Vendor</Card.Title>
 <Button variant="secondary" onClick={() => navigate("/vendors")}>
 <i className="fas fa-arrow-left me-2"></i>Back
 </Button>
 </Card.Header>

 <Card.Body>
 <Form onSubmit={handleSubmit}>
 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Vendor Name <span className="text-danger">*</span>
 </Form.Label>
 <Form.Control
 type="text"
 name="name"
 value={form.name}
 onChange={handleChange}
 placeholder="Enter vendor name"
 />
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Category <span className="text-danger">*</span>
 </Form.Label>
 <Form.Select
 name="category"
 value={form.category}
 onChange={handleChange}
 >
 <option value="">Select Category</option>
 {categories.map((cat) => (
 <option key={cat._id} value={cat._id}>
 {cat.name}
 </option>
 ))}
 </Form.Select>
 <Form.Text className="text-muted">
 Select vendor category
 </Form.Text>
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Contact Person <span className="text-danger">*</span>
 </Form.Label>
 <Form.Control
 type="text"
 name="contactPerson"
 value={form.contactPerson}
 onChange={handleChange}
 placeholder="Enter contact person name"
 />
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Email <span className="text-danger">*</span>
 </Form.Label>
 <Form.Control
 type="email"
 name="email"
 value={form.email}
 onChange={handleChange}
 placeholder="Enter email address"
 />
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Phone <span className="text-danger">*</span>
 </Form.Label>
 <Form.Control
 type="text"
 name="phone"
 maxLength="16"
 value={form.phone}
 onChange={handleChange}
 />
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>GST / Tax Number</Form.Label>
 <Form.Control
 type="text"
 name="gst"
 maxLength="15"
 value={form.gst}
 onChange={handleChange}
 />
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 PAN Number
 </Form.Label>
 <Form.Control
 type="text"
 name="panNumber"
 maxLength="10"
 value={form.panNumber}
 onChange={handleChange}
 placeholder="ABCDE1234F"
 />
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Aadhaar Number
 </Form.Label>
 <Form.Control
 type="text"
 name="aadhaarNumber"
 maxLength="12"
 value={form.aadhaarNumber}
 onChange={handleChange}
 placeholder="123412341234"
 />
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>PAN Card Upload</Form.Label>
 <Form.Control
 type="file"
 name="panDocument"
 accept=".pdf,.jpg,.jpeg,.png"
 onChange={handleFileChange}
 />
 <Form.Text className="text-muted">
 PDF, JPG, JPEG, PNG allowed
 </Form.Text>
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Aadhaar Card Upload</Form.Label>
 <Form.Control
 type="file"
 name="aadhaarDocument"
 accept=".pdf,.jpg,.jpeg,.png"
 onChange={handleFileChange}
 />
 <Form.Text className="text-muted">
 PDF, JPG, JPEG, PNG allowed
 </Form.Text>
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={12}>
 <Form.Group className="mb-3">
 <Form.Label>
 Address <span className="text-danger">*</span>
 </Form.Label>
 <Form.Control
 as="textarea"
 rows={3}
 name="address"
 value={form.address}
 onChange={handleChange}
 placeholder="Enter complete address"
 />
 </Form.Group>
 </Col>
 </Row>
 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 State <span className="text-danger">*</span>
 </Form.Label>
 <Form.Select
 name="state"
 value={form.state}
 onChange={handleChange}
 required
 >
 <option value="">Select State</option>
 {INDIAN_STATES.map((stateName) => (
 <option key={stateName} value={stateName}>
 {stateName}
 </option>
 ))}
 </Form.Select>
 </Form.Group>
 </Col>
 </Row>

 {/* ==========================
 BANK DETAILS
 ========================== */}
 <Row>
 <Col md={3}>
 <Form.Group className="mb-3">
 <Form.Label>Bank Name</Form.Label>
 <Form.Control
 type="text"
 name="bankName"
 value={form.bank.bankName}
 onChange={handleBankChange}
 placeholder="Bank Name"
 />
 </Form.Group>
 </Col>

 <Col md={3}>
 <Form.Group className="mb-3">
 <Form.Label>Account Holder Name</Form.Label>
 <Form.Control
 type="text"
 name="accountHolder"
 value={form.bank.accountHolder}
 onChange={handleBankChange}
 placeholder="Account Holder Name"
 />
 </Form.Group>
 </Col>

 <Col md={3}>
 <Form.Group className="mb-3">
 <Form.Label>Account No</Form.Label>
 <Form.Control
 type="text"
 name="accountNo"
 maxLength="18"
 value={form.bank.accountNo}
 onChange={handleBankChange}
 />
 </Form.Group>
 </Col>

 <Col md={3}>
 <Form.Group className="mb-3">
 <Form.Label>Confirm Account No</Form.Label>
 <Form.Control
 type="text"
 name="confirmAccountNo"
 maxLength="18"
 value={form.bank.confirmAccountNo}
 onChange={handleBankChange}
 />
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={3}>
 <Form.Group className="mb-3">
 <Form.Label>IFSC Code</Form.Label>
 <Form.Control
 type="text"
 name="ifsc"
 maxLength="11"
 value={form.bank.ifsc}
 onChange={handleBankChange}
 />
 </Form.Group>
 </Col>
 </Row>

 <Form.Text className="text-muted mb-3 d-block">
 Enter bank name, account number, IFSC code, etc.
 </Form.Text>

 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Status</Form.Label>
 <Form.Select
 name="status"
 value={form.status}
 onChange={handleChange}
 >
 {statuses.map((status, i) => (
 <option key={i} value={status}>
 {status}
 </option>
 ))}
 </Form.Select>
 </Form.Group>
 </Col>
 </Row>

 <div className="d-flex gap-2 mt-3">
 <Button type="submit" variant="primary" disabled={loading}>
 {loading ? (
 <>
 <span className="spinner-border spinner-border-sm me-2"></span>
 Creating...
 </>
 ) : (
 <>
 <i className="fas fa-save me-2"></i>Create Vendor
 </>
 )}
 </Button>

 <Button
 type="button"
 variant="danger"
 disabled={loading}
 onClick={() => navigate("/vendors")}
 >
 <i className="fas fa-times me-2"></i>Cancel
 </Button>
 </div>
 </Form>
 </Card.Body>
 </Card>
 </Col>
 </Row>
 </Fragment>
 );
};

export default VendorAdd;
